import React, { useEffect, useState } from "react";
import { initTheme, type ThemePref } from "./theme.js";

/** One native control on public and authenticated surfaces. It never remounts its page. */
export function Appearance(): React.ReactElement {
  const controller = initTheme();
  const [pref, setPref] = useState<ThemePref>(() => controller.state().pref);
  useEffect(() => {
    const update = () => setPref(controller.state().pref);
    window.addEventListener("pw-theme-change", update);
    update();
    return () => window.removeEventListener("pw-theme-change", update);
  }, [controller]);
  return (
    <label className="appearance">
      <span>Appearance</span>
      <select value={pref} onChange={(event) => controller.choose(event.target.value as ThemePref)}>
        <option value="system">System</option>
        <option value="light">Light</option>
        <option value="dark">Dark</option>
      </select>
    </label>
  );
}
